var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 179.73,
    height: 179.73,
    viewBox: "0 0 179.73 179.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(-1 -277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_101---Files",
    "data-name": "101---Files",
    transform: "translate(1 277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M86.937,42.937H56.982A11.982,11.982,0,0,1,45,30.955V1Z",
    transform: "translate(89.798 1.996)",
    fill: "#e8edfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M150.775,56.937V134.82A11.982,11.982,0,0,1,138.793,146.8H12.982A11.982,11.982,0,0,1,1,134.82V26.982A11.982,11.982,0,0,1,12.982,15H54.919A12.012,12.012,0,0,1,66.9,26.982v5.991A11.982,11.982,0,0,0,78.883,44.955h59.91A11.982,11.982,0,0,1,150.775,56.937Z",
    transform: "translate(1.996 29.933)",
    fill: "#ebffe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M52.987,25H44A11.982,11.982,0,0,1,55.982,36.982v77.883A11.982,11.982,0,0,1,44,126.847h8.987a11.982,11.982,0,0,0,11.982-11.982V36.982A11.982,11.982,0,0,0,52.987,25Z",
    transform: "translate(87.802 49.888)",
    fill: "#bafe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M27.982,26.982v5.991A11.982,11.982,0,0,0,39.964,44.955h8.987A11.982,11.982,0,0,1,36.969,32.973V26.982A12.012,12.012,0,0,0,24.987,15H16A12.012,12.012,0,0,1,27.982,26.982Z",
    transform: "translate(31.928 29.933)",
    fill: "#bafe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M134.829,42.937V147.78a11.982,11.982,0,0,1-11.982,11.982H110.865V84.874A11.982,11.982,0,0,0,98.883,72.892H38.973A11.982,11.982,0,0,1,26.991,60.91V54.919A11.922,11.922,0,0,0,21,44.555V12.982A12.018,12.018,0,0,1,32.982,1h59.91V30.955a11.982,11.982,0,0,0,11.982,11.982Z",
    transform: "translate(41.906 1.996)",
    fill: "#bafe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M53.982,42.937h8.987A11.982,11.982,0,0,1,50.987,30.955V1H42V30.955A11.982,11.982,0,0,0,53.982,42.937Z",
    transform: "translate(83.811 1.996)",
    fill: "#91e56f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M63.982,15V119.843A11.982,11.982,0,0,1,52,131.825h8.987a11.982,11.982,0,0,0,11.982-11.982V15Z",
    transform: "translate(103.766 29.933)",
    fill: "#91e56f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M1,134.82A11.982,11.982,0,0,0,12.982,146.8h8.987A11.982,11.982,0,0,1,9.987,134.82V26.982A11.982,11.982,0,0,1,21.969,15H12.982A11.982,11.982,0,0,0,1,26.982Z",
    transform: "translate(1.996 29.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "M0,47H5.991V70.964H0Z",
    transform: "translate(0 93.789)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 2.5,
    cy: 3.5,
    rx: 2.5,
    ry: 3.5,
    transform: "translate(0 148)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M136.915.878A3,3,0,0,0,134.8,0H74.888A15,15,0,0,0,59.91,14.978V32.951a3,3,0,0,0,5.991,0V14.978a8.987,8.987,0,0,1,8.987-8.987H131.8v26.96A15,15,0,0,0,146.78,47.928h26.96V149.775a8.987,8.987,0,0,1-8.987,8.986h-8.986V86.87a15,15,0,0,0-14.978-14.978H80.879a8.987,8.987,0,0,1-8.987-8.987V56.915A15,15,0,0,0,56.915,41.937H14.978A15,15,0,0,0,0,56.915v83.874a3,3,0,1,0,5.991,0V56.915a8.987,8.987,0,0,1,8.987-8.987H56.915A8.987,8.987,0,0,1,65.9,56.915v5.991A15,15,0,0,0,80.879,77.883h59.91a8.987,8.987,0,0,1,8.987,8.987v77.883a8.987,8.987,0,0,1-8.987,8.987H14.978a8.987,8.987,0,0,1-8.987-8.987,3,3,0,0,0-5.991,0A15,15,0,0,0,14.978,179.73H140.789a15,15,0,0,0,14.978-14.978h8.986a15,15,0,0,0,14.978-14.978V44.933a3,3,0,0,0-.878-2.118Zm.878,32.073V10.227l31.71,31.71H146.78A8.987,8.987,0,0,1,137.793,32.951Z",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    d: "M29,17.991h5.991a3,3,0,1,0,0-5.991H29a3,3,0,1,0,0,5.991Z",
    transform: "translate(51.883 23.946)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    "data-name": "Shape",
    d: "M36,17.991H56.964a3,3,0,1,0,0-5.991H36a3,3,0,0,0,0,5.991Z",
    transform: "translate(65.852 23.946)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-12",
    "data-name": "Shape",
    d: "M29,21.991h5.991a3,3,0,1,0,0-5.991H29a3,3,0,1,0,0,5.991Z",
    transform: "translate(51.883 31.928)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-13",
    "data-name": "Shape",
    d: "M36,21.991H56.964a3,3,0,1,0,0-5.991H36a3,3,0,0,0,0,5.991Z",
    transform: "translate(65.852 31.928)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-14",
    "data-name": "Shape",
    d: "M29,25.991h5.991a3,3,0,1,0,0-5.991H29a3,3,0,1,0,0,5.991Z",
    transform: "translate(51.883 39.91)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-15",
    "data-name": "Shape",
    d: "M36,25.991H56.964a3,3,0,1,0,0-5.991H36a3,3,0,0,0,0,5.991Z",
    transform: "translate(65.852 39.91)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-16",
    "data-name": "Shape",
    d: "M7,29.982a3,3,0,0,0,3-3V21A3,3,0,0,0,4,21v5.991A3,3,0,0,0,7,29.982Z",
    transform: "translate(7.982 35.919)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-17",
    "data-name": "Shape",
    d: "M4,69.933a3,3,0,0,0,5.991,0V28A3,3,0,1,0,4,28Z",
    transform: "translate(7.982 49.888)",
    fill: "#08cd34"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPackage);
export default __webpack_public_path__ + "static/media/green-package.aac6679e6ec45ea8b675d1160748dacf.svg";
export { ForwardRef as ReactComponent };